import React from 'react';
import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd';
import { Banner } from '../Banner/Banner';
import { StyledTextButton } from '../../PlusWebsiteEditor.styles';
import { Banner as IBanner } from '../../types/banners';
import { Base64 } from '../../types/websiteConfiguration';
import { reorder } from '../DraggableHOC/Draggable.utils';
import * as array from '../../utils/array';
import { ArrayErrorGetter, BlurHandler, ChangeHandler } from '../../types/handlers';
import { MAX_BANNERS_COUNT } from '../../constants';

type Props = {
  items: IBanner[];
  onChange: ChangeHandler<Array<IBanner>>;
  onBlur: BlurHandler;
  getError: ArrayErrorGetter<IBanner>;
};

const BannersEditor = ({ items, onChange, onBlur, getError }: Props) => {
  const isMaxAmount = items.length === MAX_BANNERS_COUNT;

  const handleDragEnd = (result: DropResult) => {
    onChange(reorder(items, result), true);
  };

  const handleAddMore = () => {
    const newBanner: IBanner = {
      id: Math.floor(Math.random() * 1000000),
      image_url: '',
      title: '',
      link: '',
    };

    onChange(items.concat([newBanner]));
  };

  const handleDelete = (itemId: number) => {
    onChange(array.deleteById(items, itemId), true);
  };

  const handleImageChange = (itemId: number, image: Base64) => {
    onChange(array.updateFieldById(items, itemId, 'image', image), true);
  };

  const handleFieldChange = (itemId: number, fieldName: string, value: string) => {
    onChange(array.updateFieldById(items, itemId, fieldName, value));
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="banners">
        {(droppableProvided) => (
          <div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
            {items.map((item, i) => (
              <Draggable index={i} key={item.id} draggableId={String(item.id)}>
                {(draggableProvided, draggableSnapshot) => (
                  <Banner
                    onImageChange={handleImageChange.bind(null, item.id)}
                    onFieldChange={handleFieldChange.bind(null, item.id)}
                    onBlur={onBlur}
                    error={getError()?.[i]}
                    index={i}
                    onDelete={handleDelete.bind(null, item.id)}
                    item={item}
                    provided={draggableProvided}
                    snapshot={draggableSnapshot}
                  />
                )}
              </Draggable>
            ))}
            {droppableProvided.placeholder}
          </div>
        )}
      </Droppable>
      <div>{!isMaxAmount && <StyledTextButton onClick={handleAddMore}>+ Add More</StyledTextButton>}</div>
    </DragDropContext>
  );
};

export default BannersEditor;
